
import { app } from './firebaseConfig';

import {
    getAuth,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    signOut,
    onAuthStateChanged,
} from "firebase/auth";
import { AuthStateContext } from '../context/authContext';
import { toast } from 'react-toastify';

const auth = getAuth(app);

interface PropsLogin {
    email: string
    password: string
}

const loginWithCredentials = async ({ email, password }: PropsLogin) => {
    try {
        const response = await signInWithEmailAndPassword(auth, email, password)
        // navigate('/historial-encuestas');
        return response.user.uid;

    } catch (err) {
        // @ts-ignore
        switch (err.code) {
            case 'auth/invalid-login-credentials': {
                toast.error('Los datos de inicio de sesión no son correctos');

                break;
            }
            default: {
                toast.error('No es posible iniciar sesión, intente más tarde');
            }
        }
        console.error(err);
    }
};

const signInWithCredentials = async ({ email, password }: PropsLogin) => {
    try {
        const response = await createUserWithEmailAndPassword(auth, email, password);

        return response.user.uid
        // await addDoc(collection(db, "users"), {
        //     uid: user.uid,
        //     name,
        //     authProvider: "local",
        //     email,
        // });
    } catch (err) {
        console.error(err);
    }
};

type StateDispatch = React.Dispatch<React.SetStateAction<Pick<AuthStateContext, "status" | "userId">>>

export const onAuthStateHasChanged = (setSession: StateDispatch) => {
    onAuthStateChanged(auth, user => {

        if (!user) return setSession({ status: 'no-authenticated', userId: null })

        setSession({ status: 'authenticated', userId: user!.uid })
    })
}

const logout = async () => {
    await signOut(auth);
};

export {
    auth,
    loginWithCredentials,
    signInWithCredentials,
    logout
}